export default String.raw`
<g id="Blog homepage/mobile">
    <rect width="360" height="436" class="bgColor"/>
    <g id="Frame 254">
        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="16" y="42.5455">TRANSLATION_Prv_NewestArticles</tspan></text>
        <g id="4. Text Button" class="iconColors">
            <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="202.412" y="41.0909">TRANSLATION_Prv_ShowAll</tspan></text>
            <g id="Arrows/chevron right">
                <use transform="translate(324, 28)" href="#chevron-right" width="16" height="16"></use>
            </g>
        </g>
    </g>
    <g id="Banners">
        <g>
            <g id="Frame 221">
                <image x="16" y="76" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="242" height="164" xlink:href="./img/previewElements/news_one.png" />
            </g>
            <g id="Frame 232">
                <g id="Frame 238">
                    <g id="Frame 452">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="16" font-weight="600" letter-spacing="0px"><tspan x="16" y="267.818">TRANSLATION_Prv_News_ArticleOne_Title</tspan></text>
                    </g>
                    <g id="Frame 453">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="16" y="303.091">TRANSLATION_Prv_News_ArticleOne_Description_LineOne </tspan><tspan x="16" y="323.091">TRANSLATION_Prv_News_ArticleOne_Description_LineTwo</tspan><tspan x="16" y="343.091">TRANSLATION_Prv_News_ArticleOne_Description_LineThree</tspan></text>
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="16" y="368.364">TRANSLATION_Prv_News_ArticleOne_Tags</tspan></text>
                    </g>
                    <g id="Frame 451">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="16" y="404.364">PREVIEW_FIRSTPOSTDATE</tspan></text>
                        <g id="4. Text Button_2" class="iconColors">
                            <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="150.365" y="405.091">TRANSLATION_Prv_ReadMore</tspan></text>
                            <g id="Arrows/chevron right_2">
                                <use transform="translate(238, 392)" href="#chevron-right" width="16" height="16"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g>
            <g id="Frame 221_2">
                <image x="274" y="76" clip-path="inset(0% round 8px)" preserveAspectRatio="xMidYMid slice" width="242" height="164" xlink:href="./img/previewElements/news_two.png" />
            </g>
            <g id="Frame 232_2">
                <g id="Frame 238_2">
                    <g id="Frame 452_2">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="16" font-weight="600" letter-spacing="0px"><tspan x="274" y="267.818">TRANSLATION_Prv_News_ArticleTwo_Title</tspan></text>
                    </g>
                    <g id="Frame 453_2">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="274" y="303.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineOne</tspan><tspan x="274" y="323.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineTwo</tspan><tspan x="274" y="343.091">TRANSLATION_Prv_News_ArticleTwo_Description_LineThree</tspan></text>
                        <text class="iconColors" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="274" y="368.364">TRANSLATION_Prv_News_ArticleTwo_Tags</tspan></text>
                    </g>
                    <g id="Frame 451_2">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="274" y="404.364">PREVIEW_SECONDPOSTDATE</tspan></text>
                    </g>
                </g>
            </g>
        </g>
    </g>
</g>
`;